import { actionCopyIt } from "./actionCopy";

export const diaryCopyIt = {
    diaries: "Diari",
    diary: "Diario",
    diaryPeriod: "Periodo del diario",
    toDo: "Da fare",
    results: "Risultati",
    toNow: "- Oggi",
    edit: actionCopyIt.edit,
    change: "Modificare",
    details: "Dettagli",
    deleteEntry: "Eliminare l'inserimento",
    done: actionCopyIt.done,
    next: actionCopyIt.next,
    save: actionCopyIt.save,
    saving: actionCopyIt.saving,
    cancel: actionCopyIt.cancel,
    date: "Data",
    time: "Ora",
    noSteps: "Nessun passaggio.",
    step: "Passaggio",
    chooseStep: "Scegliere un passaggio",
    currently: "Attualmente",
    general: "Generale",
    procedureDetails: "Dettagli dell'intervento",
    hospitalReferenceNumber: "Numero di cartella ospedaliera",
    hospitalNumber: "Numero di cartella ospedaliera",
    hospitalNumberDescription: "Numero di cartella ospedaliera per tutti i monitoraggi.",
    enterHospitalNumber: "Inserire il numero di cartella ospedaliera",
    startDate: "Data di inizio",
    procedureDate: "Data dell'intervento",
    referenceDate: "Data di riferimento",
    referenceDateDescription: "La data dell'iniezione, dell'operazione o di un altro intervento.",
    baselineDate: "Data basale",
    baselineDateDescription:
        "La data da cui si misura il follow-up, ad esempio l'arruolamento del paziente nello studio. I questionari sono programmati a partire da questa data.",
    patientBaselineDate: "Data di inizio",
    patientBaselineDateDescription: "La data da cui vengono programmate le Sue domande di follow-up.",
    eventDateDescription: "I questionari di follow-up sono programmati a partire da questa data.",
    patientEventDateDescription: "Le Sue domande di follow-up sono programmate a partire da questa data.",
    endDate: "Data di fine",
    contactPerson: "Persona di contatto",
    contactPersonDescription:
        "Contatto principale per questo diario. Prema Copiare per copiare il suo indirizzo e-mail.",
    loadingContact: "Caricamento del contatto...",
    side: "Lato",
    anatomicArea: "Area anatomica",
    questionnaireSide: "Lato del questionario",
    questionnaireSideDescription: "Il lato a cui si riferisce questo questionario.",
    notSet: "Non definito",
    trackerSettings: "Impostazioni del monitoraggio",
    consent: "Consenso",
    consentForm: "Modulo di consenso",
    consentDetails: "Dettagli",
    sign: "Firmare",
    signed: "Firmato",
    signedAt: (date) => `Firmato il ${date}`,
    requiresSignature: "Firma richiesta",
    actionRequiredSignConsent: "Azione richiesta: firmare il consenso",
    signConsentBeforeContinuing: (count) =>
        `Deve firmare ${count > 1 ? "i seguenti moduli di consenso" : "il seguente modulo di consenso"} prima di continuare:`,
    signConsentNow: "Firmare il consenso ora",
    detailsStillNeed: "Informazioni ancora necessarie",
    detailsStillNeedDescription:
        "Completi queste informazioni. Se il lato è ancora mancante, glielo chiederemo nella schermata di configurazione.",
    injectionSide: "Lato dell'iniezione",
    injectionAnatomicArea: "Area anatomica dell'iniezione",
    surgerySide: "Lato dell'operazione",
    shockwaveSide: "Lato delle onde d'urto",
    shockwaveAnatomicArea: "Area anatomica delle onde d'urto",
    yourEntries: "I Suoi inserimenti",
    noDiary: "Nessun diario",
    noCompletedEntries: "Nessun inserimento completato al momento.",
    form: "modulo",
    forms: "moduli",
    item: "elemento",
    items: "elementi",
    questionnaire: "Questionario",
    questionnaires: "Questionari",
    injection: "Iniezione",
    surgery: "Operazione",
    shockwave: "Onde d'urto",
    consultation: "Consulto",
    procedure: "Intervento",
    procedures: (count) => `${count} interventi`,
    task: "attività",
    tasks: "attività",
    toDoEmpty: "È in pari - non c'è nulla da fare al momento.",
    blocked: "In attesa dei moduli precedenti",
    blockedEmpty: "Nessun modulo è in attesa di passaggi precedenti.",
    formsLockedUntilConsentSigned: "I Suoi moduli saranno sbloccati dopo la firma del consenso richiesto.",
    completePreviousFormFirst: (formName) => `Completi prima ${formName}`,
    doneEmpty: "I passaggi completati compariranno qui.",
    complete: "Completato",
    due: "Da fare",
    upToDate: "Aggiornato",
    allCaughtUp: "Tutto aggiornato",
    formsNeedAttention: "Moduli da gestire",
    progress: "Andamento",
    completed: "Completato",
    notNeeded: "Non necessario",
    dueNow: "Da fare ora",
    waiting: "In attesa",
    locked: "Bloccato",
    lockedByEarlierEntry: "Bloccato - completi prima un inserimento precedente",
    lockedUntilPreviousFormComplete: (formName) => `Bloccato - completi prima ${formName}`,
    availableLater: "Disponibile più tardi",
    nextDue: "Prossima scadenza",
    dueOn: (date) => `Da fare il ${date}`,
    nextScheduledSentence: (formLabel, scheduleLabel, date) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` per ${schedule.toLowerCase()}` : "";
        if (due) return `Il Suo ${formLabel}${timing} è da compilare il ${due}.`;
        return `Il Suo ${formLabel}${timing} è da compilare a breve.`;
    },
    noEntriesScheduled: "Nessun inserimento pianificato al momento.",
    showLess: "Mostrare meno",
    showMore: (count) => `Mostrare altro (${count} ${count === 1 ? "scadenza" : "scadenze"} in più)`,
    showAllTimings: (count) => `Mostrare le ${count} scadenze`,
    expand: "Espandere",
    submitted: (completed, total) => `${completed} su ${total} inviati`,
    submittedOn: (date) => `Inviato il ${date}`,
    noDataYet: "Nessun dato al momento",
    noDataDescription: "Inizi ad aggiungere inserimenti per vedere il Suo andamento nel tempo",
    notEnoughDataYet: "Dati ancora insufficienti",
    notEnoughDataDescription: "Per visualizzare i grafici servono almeno due inserimenti.",
    addEntry: "Aggiungere un inserimento",
    addEntryFor: (formSlug, timingLabel) => `Aggiungere un inserimento ${formSlug} ${timingLabel}`,
    addExtraScore: "Aggiungere un punteggio aggiuntivo",
    addExtraScoreTitle: "Aggiungere un punteggio aggiuntivo",
    addExtraScoreDescription:
        "Questo passaggio è facoltativo. Continui solo se desidera registrare una misurazione aggiuntiva, oppure se Le è stato chiesto un aggiornamento.",
    addForm: "Aggiungere un modulo",
    entryDue: (label) => `Il Suo inserimento per ${label.toLowerCase()} è da compilare.`,
    nextEntryDueOn: (label, date) => `Il Suo inserimento « ${label.toLowerCase()} » è da compilare il ${date}.`,
    entriesDueForForm: (count) => `${count} inserimenti da compilare per questo modulo.`,
    formWithEntriesDue: (formName, entries) =>
        `${formName} ha ${entries} ${entries === 1 ? "inserimento da compilare" : "inserimenti da compilare"}. Gli altri Suoi moduli sono aggiornati.`,
    formsWithEntriesDue: (forms, entries) =>
        `Ha ${forms} ${forms === 1 ? "modulo" : "moduli"} con ${entries} ${
            entries === 1 ? "inserimento da compilare" : "inserimenti da compilare"
        }.`,
    allFormsComplete: "Tutti i Suoi moduli sono completati.",
    allEntriesComplete: "Tutti gli inserimenti sono completati",
    entriesDueNow: (count) => `${count} inserimenti da compilare ora`,
    completeYourEntry: (label) => `Completi il Suo inserimento « ${label.toLowerCase()} »`,
    questionnaireDueNow: "Questionario da compilare ora",
    nextEntryLabel: (label) => `Prossimo inserimento: ${label}`,
    waitingForNextEntry: "In attesa del prossimo inserimento",
    readyLabel: (label) => `Pronto: ${label}`,
    readyToComplete: "Pronto per la compilazione",
    reminderText: "Le invieremo un SMS quando sarà da fare.",
    reminderEmail: "Le invieremo un'e-mail quando sarà da fare.",
    reminderTextAndEmail: "Le invieremo un SMS e un'e-mail quando sarà da fare.",
    reminderNone:
        "Attivi i promemoria via SMS o e-mail nelle Sue impostazioni se desidera un promemoria al momento giusto.",
    entrySubmitted: "Inserimento trasmesso.",
    completeWithCareTeam: "Completato e in attesa di valutazione.",
    formNumber: (index) => `Modulo n. ${index}`,
    dateOfProcedure: (phrase) => `Data dell'intervento (${phrase})`,
    wrongDate: "Data errata?",
    editHere: "Modificare qui",
    showAnswers: "Mostrare le risposte",
    hideAnswers: "Nascondere le risposte",
    showAnswersDescription: "Consulti le risposte oppure prema Modificare su una scadenza per aggiornare le risposte",
    entryCountLabel: (count) => (count === 1 ? "1 inserimento" : `${count} inserimenti`),
    timing: "Scadenza",
    referredBy: (name) => `Inviato da: ${name}`,
    performedBy: (name) => `Eseguito da: ${name}`,
    method: (method) => `Metodo: ${method}`,
    injectionDetails: "Informazioni sull'iniezione",
    unknown: "Sconosciuto",
    noDateSpecified: "Nessuna data indicata",
    noInjectionDetails: "Nessuna informazione sull'iniezione fornita.",
    sideNotSpecified: "Lato non specificato",
    areaNotSpecified: "Area non specificata",
    siteNotSpecified: "Sede non specificata",
    substanceNotSpecified: "Sostanza non specificata",
    blankAnswer: "Lasciato vuoto",
    listEmptyTitle: "Nessun diario al momento",
    listEmptyDescription: "I diari creati per Lei compaiono qui",
    listCheckAgain: "Verificare di nuovo",
    listNeedsAttention: "Richiede la Sua attenzione",
    listNeedsAttentionDescription: "Diari i cui moduli attendono il Suo prossimo inserimento.",
    listOngoing: "In corso",
    listOngoingDescription: "Diari in corso o in attesa del Suo primo inserimento.",
    listUpToDateDescription: "Diari in corso senza inserimenti da compilare al momento.",
    listNoOngoing: "Nessun diario in corso al momento",
    listCompletedDescription: "Diari completati (che non raccolgono più inserimenti).",
    listNoCompleted: "Nessun diario completato al momento",
    listOpenDiary: "Aprire il diario",
    listReviewDiary: "Consultare il diario",
};
